// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"footer_disable-scroll__3mcQd"};